<script>
import ErrorIcon from '@/components/commons/Illustrations/graphicSVG/ErrorIcon.vue'
import SuccessIcon from '@/components/commons/Illustrations/graphicSVG/SuccessIcon.vue'
import CloseIcon from '@/components/commons/Illustrations/graphicSVG/closeIcon.vue'

export default {
  name: 'KeycloakAlert',
  components: {
    ErrorIcon,
    SuccessIcon,
    CloseIcon
  },
  props: {
    type: {
      type: String,
      required: true,
      validator: value => ['success', 'error'].includes(value)
    }
  },
  computed: {
    alertTitle() {
      return this.type === 'success'
        ? this.$t('message.homeComponent.alert.falabella.success.title')
        : this.$t('message.homeComponent.alert.falabella.fail.title')
    },
    alertMessage() {
      return this.type === 'success'
        ? this.$t('message.homeComponent.alert.falabella.success.subtitle')
        : this.$t('message.homeComponent.alert.falabella.fail.subtitle')
    },
    containerClasses() {
      return this.type === 'success'
        ? 'gap-4 border-green-300 border-2 rounded bg-green-100 p-3'
        : 'gap-4 border-red-300 border-2 rounded bg-red-100 p-3'
    },
    iconClasses() {
      return this.type === 'success' ? 'text-green-700 ' : 'text-red-700 '
    },
    textClasses() {
      return this.type === 'success' ? 'text-green-800 ml-3' : 'text-red-800 ml-3'
    }
  }
}
</script>

<template>
  <div :class="containerClasses">
    <div class="flex items-center justify-between">
      <div class="flex items-center ">
        <SuccessIcon v-if="type === 'success'" :class="iconClasses" />
        <ErrorIcon v-else :class="iconClasses" />
        <div>
          <p :class="`${textClasses} font-semibold`">
            {{ alertTitle }}
          </p>
          <p :class="textClasses">
            {{ alertMessage }}
          </p>
        </div>
      </div>
      <button @click="$emit('close')">
        <CloseIcon :class="iconClasses" class="cursor-pointer" @click="$emit('close')" />
      </button>
    </div>
  </div>
</template>
